import apiClient from '@/services/axios'

export async function get(bookingId, numPersons, arrival, venueSectionId, acceptSoftWarnings) {
  var params = {
    "existing-booking-id": bookingId,
    "guest-count": numPersons,
    "arrival": arrival,
    "accept-soft-warnings": true
  }

  var response = await apiClient.get(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/bookings/tables/section/' + venueSectionId, { params: params });

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to get section tables')
}
